export const QUERY_KEYS = {
  // User-related queries
  USER: "user",
  USER_ME: ["user", "me"],

  // Application-related queries
  APPLICATIONS: "applications",
  APPLICATIONS_LIST: ["applications", "list"],
  APPLICATION_BY_ID: (id: string | number) => ["applications", "detail", id],
  UPDATE_APPLICATION: "updateApplication",

  APPLICATION: "application",

  // Appeal-related queries
  APPEALS: "appeals",
  APPEALS_LIST: ["appeals", "list"],
  APPEAL_BY_ID: (id: string | number) => ["appeals", "detail", id],

  // Declaration-related queries
  DECLARATIONS: "declarations",

  ORGANIZATION_INVITATIONS: "organization-invitations",
  ORGANIZATION_MEMBERS: "organization-members",
  MY_ORGANIZATION: "my-organization",

  // Collaborator-related queries
  COLLABORATORS: ["collaborators", "list"],
  COLLABORATOR_BY_ID: (id: string | number) => ["collaborators", "detail", id],
  CHECK_COLLABORATOR_EMAIL: (email: string, applicationId: number) => [
    "collaborators",
    "check",
    email,
    applicationId,
  ],

  // Upload-related queries
  UPLOAD_BY_ID: (id: string | number) => ["uploads", "detail", id],

  // AI Detection queries
  AI_DETECTION_BREAKDOWN: (applicationId: string | number) => [
    "ai-detection-breakdown",
    applicationId,
  ],
  CHAPTER_TEXTS: (applicationId: string | number) => [
    "chapter-texts",
    applicationId,
  ],

  // Transaction-related queries
  TRANSACTION_BY_APPLICATION_ID: (applicationId: string | number) => [
    "transactions",
    "by-application",
    applicationId,
  ],

  // Certificate-related queries
  CERTIFICATE_BY_NUMBER: (num: string) => ["certificates", "detail", num],

  // University stats
  UNIVERSITY_STATS: (period: string) => ["university-stats", period],

  // University access management
  UNIVERSITY_ACCESS_MEMBERS: (orgId: string) => ["university-access", "members", orgId],
  UNIVERSITY_ACCESS_INVITATIONS: (orgId: string) => ["university-access", "invitations", orgId],
} as const;
